import { computed, Ref } from "@vue/composition-api";

export interface MinLengthAttr {
  minLength: Readonly<Ref<boolean>>;
  minLengthError: Readonly<Ref<boolean>>;
}

export const minLengthValidator = (
  inputRef: Ref<string | number>,
  inputValueDirty: Ref<boolean>,
  requiredLength: number
): MinLengthAttr => {
  const minLength = computed(
    () => inputRef.value.toString().length >= requiredLength
  );
  return {
    minLength,
    minLengthError: computed(() => !minLength.value && inputValueDirty.value)
  };
};
